import type { FrontendAuthIdentity } from './session.js';

export const EMBEDDED_AUTH_REQUEST = 'nwm-oss:embedded-auth-request';
export const EMBEDDED_AUTH_RESPONSE = 'nwm-oss:embedded-auth-response';
export const EMBEDDED_AUTH_QUERY_PARAM = 'shellOrigin';
export const EMBEDDED_AUTH_REQUEST_TIMEOUT_MS = 3000;

export interface EmbeddedAuthPayload {
  readonly isAuthenticated: boolean;
  readonly accessToken: string | null;
  readonly identity: FrontendAuthIdentity | null;
}

export interface EmbeddedAuthRequestMessage {
  readonly type: typeof EMBEDDED_AUTH_REQUEST;
}

export interface EmbeddedAuthResponseMessage {
  readonly type: typeof EMBEDDED_AUTH_RESPONSE;
  readonly payload: EmbeddedAuthPayload;
}

export function readEmbeddedShellOrigin(search: string): string | null {
  const params = new URLSearchParams(search);
  const shellOrigin = params.get(EMBEDDED_AUTH_QUERY_PARAM);

  if (shellOrigin) {
    return shellOrigin;
  }

  if (typeof document === 'undefined' || !document.referrer) {
    return null;
  }

  try {
    return new URL(document.referrer).origin;
  } catch {
    return null;
  }
}
